/* ../src/components/App.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_component,
	create_in_transition,
	create_out_transition,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	set_data,
	set_style,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import { onMount } from "svelte";
import { fly } from "svelte/transition";
import { TezosToolkit } from "@taquito/taquito";
import config from "../config";
import ConnectWallet from "./ConnectWallet.svelte";
import UserAddress from "./UserAddress.svelte";
import TransferTokens from "./TransferTokens.svelte";
import TokenType from "./TokenType.svelte";
import store from "../store";

function create_else_block_3(ctx) {
	let p;
	let p_intro;
	let p_outro;
	let current;

	return {
		c() {
			p = element("p");
			p.textContent = "XTZ Faucet";
		},
		m(target, anchor) {
			insert(target, p, anchor);
			current = true;
		},
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (p_outro) p_outro.end(1);
				if (!p_intro) p_intro = create_in_transition(p, fly, { y: 30, duration: 200, delay: 200 });
				p_intro.start();
			});

			current = true;
		},
		o(local) {
			if (p_intro) p_intro.invalidate();
			p_outro = create_out_transition(p, fly, { y: -30, duration: 200 });
			current = false;
		},
		d(detaching) {
			if (detaching) detach(p);
			if (detaching && p_outro) p_outro.end();
		}
	};
}

// (101:82) 
function create_if_block_4(ctx) {
	let p;
	let p_intro;
	let p_outro;
	let current;

	return {
		c() {
			p = element("p");
			p.textContent = "FA2 Token Faucet";
		},
		m(target, anchor) {
			insert(target, p, anchor);
			current = true;
		},
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (p_outro) p_outro.end(1);
				if (!p_intro) p_intro = create_in_transition(p, fly, { y: 30, duration: 200, delay: 200 });
				p_intro.start();
			});

			current = true;
		},
		o(local) {
			if (p_intro) p_intro.invalidate();
			p_outro = create_out_transition(p, fly, { y: -30, duration: 200 });
			current = false;
		},
		d(detaching) {
			if (detaching) detach(p);
			if (detaching && p_outro) p_outro.end();
		}
	};
}

// (95:8) {#if $store.tokenType === 'fa12'}
function create_if_block_3(ctx) {
	let p;
	let p_intro;
	let p_outro;
	let current;

	return {
		c() {
			p = element("p");
			p.textContent = "FA1.2 Token Faucet";
		},
		m(target, anchor) {
			insert(target, p, anchor);
			current = true;
		},
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (p_outro) p_outro.end(1);
				if (!p_intro) p_intro = create_in_transition(p, fly, { y: 30, duration: 200, delay: 200 });
				p_intro.start();
			});

			current = true;
		},
		o(local) {
			if (p_intro) p_intro.invalidate();
			p_outro = create_out_transition(p, fly, { y: -30, duration: 200 });
			current = false;
		},
		d(detaching) {
			if (detaching) detach(p);
			if (detaching && p_outro) p_outro.end();
		}
	};
}

// (191:8) {:else}
function create_else_block_2(ctx) {
	let t;

	return {
		c() {
			t = text("Non Fungible Token");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (189:8) {#if $store.tokenType === 'fa12' || $store.tokenType === 'tezzies'}
function create_if_block_2(ctx) {
	let strike;

	return {
		c() {
			strike = element("strike");
			strike.textContent = "Non Fungible Token";
		},
		m(target, anchor) {
			insert(target, strike, anchor);
		},
		d(detaching) {
			if (detaching) detach(strike);
		}
	};
}

// (200:8) {:else}
function create_else_block_1(ctx) {
	let div;
	let span;
	let t;

	return {
		c() {
			div = element("div");
			span = element("span");
			t = text(/*nonFungibleTokens*/ ctx[2]);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, span);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty & /*nonFungibleTokens*/ 4) set_data(t, /*nonFungibleTokens*/ ctx[2]);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (198:8) {#if $store.tokenType === 'fa2_ft' || $store.tokenType === 'fa12' || $store.tokenType === 'tezzies'}
function create_if_block_1(ctx) {
	let div;
	let t;

	return {
		c() {
			div = element("div");
			t = text(/*fungibleTokens*/ ctx[1]);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t);
		},
		p(ctx, dirty) {
			if (dirty & /*fungibleTokens*/ 2) set_data(t, /*fungibleTokens*/ ctx[1]);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (214:8) {:else}
function create_else_block(ctx) {
	let input;
	let mounted;
	let dispose;

	return {
		c() {
			input = element("input");
			attr(input, "type", "range");
			attr(input, "min", "1");
			attr(input, "max", "10");
			input.value = /*nonFungibleTokens*/ ctx[2];
			attr(input, "id", "tokenSlider");
			attr(input, "class", "svelte-a8m3jp");
		},
		m(target, anchor) {
			insert(target, input, anchor);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*changeAmountTokens*/ ctx[4]),
					listen(input, "change", /*changeAmountTokens*/ ctx[4])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*nonFungibleTokens*/ 4) {
				input.value = /*nonFungibleTokens*/ ctx[2];
			}
		},
		d(detaching) {
			if (detaching) detach(input);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (205:8) {#if $store.tokenType === 'fa2_ft' || $store.tokenType === 'fa12' || $store.tokenType === 'tezzies'}
function create_if_block(ctx) {
	let input;
	let mounted;
	let dispose;

	return {
		c() {
			input = element("input");
			attr(input, "type", "range");
			attr(input, "min", "1");
			attr(input, "max", "100");
			input.value = /*fungibleTokens*/ ctx[1];
			attr(input, "id", "tokenSlider");
			attr(input, "class", "svelte-a8m3jp");
		},
		m(target, anchor) {
			insert(target, input, anchor);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*changeAmountTokens*/ ctx[4]),
					listen(input, "change", /*changeAmountTokens*/ ctx[4])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*fungibleTokens*/ 2) {
				input.value = /*fungibleTokens*/ ctx[1];
			}
		},
		d(detaching) {
			if (detaching) detach(input);
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let main;
	let div10;
	let div2;
	let tokentype;
	let t0;
	let div0;
	let current_block_type_index;
	let if_block0;
	let t1;
	let div1;
	let connectwallet;
	let t2;
	let br0;
	let t3;
	let div3;
	let input0;
	let input0_checked_value;
	let label0;
	let t5;
	let input1;
	let input1_checked_value;
	let label1;
	let t7;
	let br1;
	let t8;
	let useraddress;
	let t9;
	let br2;
	let t10;
	let div4;
	let input2;
	let t11;
	let label2;
	let t13;
	let input3;
	let input3_disabled_value;
	let t14;
	let label3;
	let t15;
	let br3;
	let t16;
	let div8;
	let div6;
	let div5;
	let t18;
	let t19;
	let div7;
	let t20;
	let br4;
	let t21;
	let div9;
	let transfertokens;
	let t22;
	let br5;
	let t23;
	let div11;
	let a0;
	let t24;
	let a1;
	let i1;
	let a1_href_value;
	let t25;
	let a2;
	let t26;
	let a3;
	let t27;
	let a4;
	let current;
	let mounted;
	let dispose;
	tokentype = new TokenType({});
	const if_block_creators = [create_if_block_3, create_if_block_4, create_else_block_3];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*$store*/ ctx[3].tokenType === "fa12") return 0;
		if (/*$store*/ ctx[3].tokenType === "fa2_ft" || /*$store*/ ctx[3].tokenType === "fa2_nft") return 1;
		return 2;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	connectwallet = new ConnectWallet({});
	useraddress = new UserAddress({});

	function select_block_type_1(ctx, dirty) {
		if (/*$store*/ ctx[3].tokenType === "fa12" || /*$store*/ ctx[3].tokenType === "tezzies") return create_if_block_2;
		return create_else_block_2;
	}

	let current_block_type = select_block_type_1(ctx, -1);
	let if_block1 = current_block_type(ctx);

	function select_block_type_2(ctx, dirty) {
		if (/*$store*/ ctx[3].tokenType === "fa2_ft" || /*$store*/ ctx[3].tokenType === "fa12" || /*$store*/ ctx[3].tokenType === "tezzies") return create_if_block_1;
		return create_else_block_1;
	}

	let current_block_type_1 = select_block_type_2(ctx, -1);
	let if_block2 = current_block_type_1(ctx);

	function select_block_type_3(ctx, dirty) {
		if (/*$store*/ ctx[3].tokenType === "fa2_ft" || /*$store*/ ctx[3].tokenType === "fa12" || /*$store*/ ctx[3].tokenType === "tezzies") return create_if_block;
		return create_else_block;
	}

	let current_block_type_2 = select_block_type_3(ctx, -1);
	let if_block3 = current_block_type_2(ctx);

	transfertokens = new TransferTokens({
			props: {
				fungibleTokens: /*fungibleTokens*/ ctx[1],
				nonFungibleTokens: /*nonFungibleTokens*/ ctx[2]
			}
		});

	return {
		c() {
			main = element("main");
			div10 = element("div");
			div2 = element("div");
			create_component(tokentype.$$.fragment);
			t0 = space();
			div0 = element("div");
			if_block0.c();
			t1 = space();
			div1 = element("div");
			create_component(connectwallet.$$.fragment);
			t2 = space();
			br0 = element("br");
			t3 = space();
			div3 = element("div");
			input0 = element("input");
			label0 = element("label");
			label0.textContent = "Carthagenet";
			t5 = space();
			input1 = element("input");
			label1 = element("label");
			label1.textContent = "Delphinet";
			t7 = space();
			br1 = element("br");
			t8 = space();
			create_component(useraddress.$$.fragment);
			t9 = space();
			br2 = element("br");
			t10 = space();
			div4 = element("div");
			input2 = element("input");
			t11 = space();
			label2 = element("label");
			label2.textContent = "Fungible Token";
			t13 = space();
			input3 = element("input");
			t14 = space();
			label3 = element("label");
			if_block1.c();
			t15 = space();
			br3 = element("br");
			t16 = space();
			div8 = element("div");
			div6 = element("div");
			div5 = element("div");
			div5.textContent = "Tokens";
			t18 = space();
			if_block2.c();
			t19 = space();
			div7 = element("div");
			if_block3.c();
			t20 = space();
			br4 = element("br");
			t21 = space();
			div9 = element("div");
			create_component(transfertokens.$$.fragment);
			t22 = space();
			br5 = element("br");
			t23 = space();
			div11 = element("div");
			a0 = element("a");
			a0.innerHTML = `<i class="fab fa-github"></i>`;
			t24 = space();
			a1 = element("a");
			i1 = element("i");
			t25 = space();
			a2 = element("a");
			a2.innerHTML = `<i class="fab fa-twitter"></i>`;
			t26 = space();
			a3 = element("a");
			a3.innerHTML = `<i class="fab fa-telegram-plane"></i>`;
			t27 = space();
			a4 = element("a");
			a4.innerHTML = `<span>BCD</span>`;
			attr(div2, "class", "title svelte-a8m3jp");
			attr(input0, "type", "radio");
			attr(input0, "id", "carthagenet");
			input0.checked = input0_checked_value = /*$store*/ ctx[3].network === "carthagenet";
			attr(label0, "for", "carthagenet");
			attr(label0, "class", "radio-label");
			attr(input1, "type", "radio");
			attr(input1, "id", "delphinet");
			input1.checked = input1_checked_value = /*$store*/ ctx[3].network === "delphinet";
			attr(label1, "for", "delphinet");
			attr(label1, "class", "radio-label");
			attr(div3, "class", "radio-container");
			attr(input2, "type", "radio");
			attr(input2, "name", "token-type");
			attr(input2, "id", "fungible-token");
			input2.checked = true;
			attr(label2, "for", "fungible-token");
			attr(label2, "class", "radio-label");
			attr(input3, "type", "radio");
			attr(input3, "name", "token-type");
			attr(input3, "id", "non-fungible-token");
			input3.disabled = input3_disabled_value = /*$store*/ ctx[3].tokenType === "fa12";
			attr(label3, "for", "non-fungible-token");
			attr(label3, "class", "radio-label");
			attr(div4, "class", "radio-container");
			attr(div6, "class", "slider-title svelte-a8m3jp");
			attr(div7, "class", "slider-container svelte-a8m3jp");
			set_style(div9, "width", "100%");
			attr(div10, "class", "box main-box svelte-a8m3jp");
			attr(a0, "href", "https://github.com/claudebarde/fa2-testnet-faucet");
			attr(a0, "class", "github");
			attr(a0, "target", "_blank");
			attr(a0, "rel", "noopener noreferrer");
			attr(i1, "class", "far fa-file-code");

			attr(a1, "href", a1_href_value = `https://better-call.dev/carthagenet/${/*$store*/ ctx[3].tokenType === "fa12"
			? config.fa12.carthagenet
			: /*$store*/ ctx[3].tokenType === "fa2_ft"
				? config.fa2_ft.carthagenet
				: config.fa2_nft.carthagenet}/operations`);

			attr(a1, "class", "contract");
			attr(a1, "target", "_blank");
			attr(a1, "rel", "noopener noreferrer");
			attr(a2, "href", "https://twitter.com/TezosTaquito");
			attr(a2, "class", "twitter");
			attr(a2, "target", "_blank");
			attr(a2, "rel", "noopener noreferrer");
			attr(a3, "href", "https://t.me/tezostaquito");
			attr(a3, "class", "telegram");
			attr(a3, "target", "_blank");
			attr(a3, "rel", "noopener noreferrer");
			attr(a4, "href", "https://better-call.dev/");
			attr(a4, "class", "bcd");
			attr(a4, "target", "_blank");
			attr(a4, "rel", "noopener noreferrer");
			attr(div11, "class", "small-box second-box svelte-a8m3jp");
			attr(main, "class", "svelte-a8m3jp");
		},
		m(target, anchor) {
			insert(target, main, anchor);
			append(main, div10);
			append(div10, div2);
			mount_component(tokentype, div2, null);
			append(div2, t0);
			append(div2, div0);
			if_blocks[current_block_type_index].m(div0, null);
			append(div2, t1);
			append(div2, div1);
			mount_component(connectwallet, div1, null);
			append(div10, t2);
			append(div10, br0);
			append(div10, t3);
			append(div10, div3);
			append(div3, input0);
			append(div3, label0);
			append(div3, t5);
			append(div3, input1);
			append(div3, label1);
			append(div10, t7);
			append(div10, br1);
			append(div10, t8);
			mount_component(useraddress, div10, null);
			append(div10, t9);
			append(div10, br2);
			append(div10, t10);
			append(div10, div4);
			append(div4, input2);
			append(div4, t11);
			append(div4, label2);
			append(div4, t13);
			append(div4, input3);
			append(div4, t14);
			append(div4, label3);
			if_block1.m(label3, null);
			append(div10, t15);
			append(div10, br3);
			append(div10, t16);
			append(div10, div8);
			append(div8, div6);
			append(div6, div5);
			append(div6, t18);
			if_block2.m(div6, null);
			append(div8, t19);
			append(div8, div7);
			if_block3.m(div7, null);
			append(div10, t20);
			append(div10, br4);
			append(div10, t21);
			append(div10, div9);
			mount_component(transfertokens, div9, null);
			append(main, t22);
			append(main, br5);
			append(main, t23);
			append(main, div11);
			append(div11, a0);
			append(div11, t24);
			append(div11, a1);
			append(a1, i1);
			append(div11, t25);
			append(div11, a2);
			append(div11, t26);
			append(div11, a3);
			append(div11, t27);
			append(div11, a4);
			current = true;

			if (!mounted) {
				dispose = [
					listen(input0, "click", /*click_handler*/ ctx[5]),
					listen(input1, "click", /*click_handler_1*/ ctx[6]),
					listen(input2, "click", /*click_handler_2*/ ctx[7]),
					listen(input3, "click", /*click_handler_3*/ ctx[8])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index !== previous_block_index) {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block0 = if_blocks[current_block_type_index];

				if (!if_block0) {
					if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block0.c();
				} else {
					
				}

				transition_in(if_block0, 1);
				if_block0.m(div0, null);
			}

			if (!current || dirty & /*$store*/ 8 && input0_checked_value !== (input0_checked_value = /*$store*/ ctx[3].network === "carthagenet")) {
				input0.checked = input0_checked_value;
			}

			if (!current || dirty & /*$store*/ 8 && input1_checked_value !== (input1_checked_value = /*$store*/ ctx[3].network === "delphinet")) {
				input1.checked = input1_checked_value;
			}

			if (!current || dirty & /*$store*/ 8 && input3_disabled_value !== (input3_disabled_value = /*$store*/ ctx[3].tokenType === "fa12")) {
				input3.disabled = input3_disabled_value;
			}

			if (current_block_type !== (current_block_type = select_block_type_1(ctx, dirty))) {
				if_block1.d(1);
				if_block1 = current_block_type(ctx);

				if (if_block1) {
					if_block1.c();
					if_block1.m(label3, null);
				}
			}

			if (current_block_type_1 === (current_block_type_1 = select_block_type_2(ctx, dirty)) && if_block2) {
				if_block2.p(ctx, dirty);
			} else {
				if_block2.d(1);
				if_block2 = current_block_type_1(ctx);

				if (if_block2) {
					if_block2.c();
					if_block2.m(div6, null);
				}
			}

			if (current_block_type_2 === (current_block_type_2 = select_block_type_3(ctx, dirty)) && if_block3) {
				if_block3.p(ctx, dirty);
			} else {
				if_block3.d(1);
				if_block3 = current_block_type_2(ctx);

				if (if_block3) {
					if_block3.c();
					if_block3.m(div7, null);
				}
			}

			const transfertokens_changes = {};
			if (dirty & /*fungibleTokens*/ 2) transfertokens_changes.fungibleTokens = /*fungibleTokens*/ ctx[1];
			if (dirty & /*nonFungibleTokens*/ 4) transfertokens_changes.nonFungibleTokens = /*nonFungibleTokens*/ ctx[2];
			transfertokens.$set(transfertokens_changes);

			if (!current || dirty & /*$store*/ 8 && a1_href_value !== (a1_href_value = `https://better-call.dev/carthagenet/${/*$store*/ ctx[3].tokenType === "fa12"
			? config.fa12.carthagenet
			: /*$store*/ ctx[3].tokenType === "fa2_ft"
				? config.fa2_ft.carthagenet
				: config.fa2_nft.carthagenet}/operations`)) {
				attr(a1, "href", a1_href_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(tokentype.$$.fragment, local);
			transition_in(if_block0);
			transition_in(connectwallet.$$.fragment, local);
			transition_in(useraddress.$$.fragment, local);
			transition_in(transfertokens.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tokentype.$$.fragment, local);
			transition_out(if_block0);
			transition_out(connectwallet.$$.fragment, local);
			transition_out(useraddress.$$.fragment, local);
			transition_out(transfertokens.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(main);
			destroy_component(tokentype);
			if_blocks[current_block_type_index].d();
			destroy_component(connectwallet);
			destroy_component(useraddress);
			if_block1.d();
			if_block2.d();
			if_block3.d();
			destroy_component(transfertokens);
			mounted = false;
			run_all(dispose);
		}
	};
}

let recipientAddress = "";

function instance($$self, $$props, $$invalidate) {
	let $store;
	component_subscribe($$self, store, $$value => $$invalidate(3, $store = $$value));
	let contract, storage, Tezos;
	let fungibleTokens = 50;
	let nonFungibleTokens = 1;
	let increaseTokens = undefined;

	const changeAmountTokens = e => {
		if ($store.tokenType === "fa12" || $store.tokenType === "fa2_ft" || $store.tokenType === "tezzies") {
			if (e.target.value > 0 && e.target.value <= 100) {
				increaseTokens = e.target.value > fungibleTokens;
				$$invalidate(1, fungibleTokens = e.target.value);
			}
		} else {
			if (e.target.value > 0 && e.target.value <= 10) {
				increaseTokens = e.target.value > nonFungibleTokens;
				$$invalidate(2, nonFungibleTokens = e.target.value);
			}
		}
	};

	onMount(async () => {
		$$invalidate(0, Tezos = new TezosToolkit(config.rpc[$store.network]));

		//Tezos.setProvider({ rpc: config.rpc[$store.network] });
		store.updateTezos(Tezos);
	});

	const click_handler = () => {
		store.updateNetwork("carthagenet");
		$store.Tezos.setRpcProvider("https://carthagenet-tezos.giganode.io");
		store.updateUserAddress("");
		store.updateRecipientAddress("");
	};

	const click_handler_1 = () => {
		store.updateNetwork("delphinet");
		$store.Tezos.setRpcProvider("https://delphinet-tezos.giganode.io");
		store.updateUserAddress("");
		store.updateRecipientAddress("");
	};

	const click_handler_2 = async () => {
		store.updateUserBalance("--");

		if ($store.tokenType === "fa12") {
			store.updateTokenType("fa12");
		} else {
			store.updateTokenType("fa2_ft");
			const storage = await $store.fa2_ft_instance.storage();
			const balance = await storage.assets.ledger.get($store.userAddress);

			if (balance) {
				store.updateUserBalance(balance.toNumber());
			} else {
				store.updateUserBalance(0);
			}
		}
	};

	const click_handler_3 = async () => {
		store.updateUserBalance("--");
		store.updateTokenType("fa2_nft");
		const ledgerJson = await fetch(`https://api.better-call.dev/v1//bigmap/carthagenet/${config.ledgerID}/keys`);
		const ledger = await ledgerJson.json();

		if (ledger) {
			const balance = ledger.filter(token => token.data.value.value === $store.userAddress).length;
			store.updateUserBalance(balance);
		} else {
			store.updateUserBalance("Not available");
		}

		if (!$store.fa2_nft_instance) {
			const contract = await Tezos.wallet.at(config.fa2_nft[$store.network]);
			store.updateFA2_nft_instance(contract);
		}
	};

	return [
		Tezos,
		fungibleTokens,
		nonFungibleTokens,
		$store,
		changeAmountTokens,
		click_handler,
		click_handler_1,
		click_handler_2,
		click_handler_3
	];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default App;